import { getGenericFormInitialValues } from "../components/form/utils/initialValues";

const prescription = "prescription";
const unspecifiedPayer = "UNSPECIFIED_PAYER_NAME";
const YES = "Yes";
const okToSpeakTo = "ok_to_speak_to";
const contactInsteadOfPatient = "contact_instead_of_patient";
const mobile = "mobile";

export const getRegeneronFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getGenericFormInitialValues(applicationForm, formJson);

  setCoverageBenefitTypeInitialValues(initialValues);
  setCareGiverIfOkToSpeakToInitialValues(initialValues);
  setPhysicianInitialValues(initialValues);

  return initialValues;
};

const setCoverageBenefitTypeInitialValues = (initialValues) => {
  Object.keys(initialValues.insurance).forEach((coverage) => {
    const insurance = initialValues.insurance?.[coverage];
    if (insurance?.categoryType?.includes(prescription)) {
      initialValues.insurance[coverage].categoryType = prescription;
    }
    if (insurance?.payerName === unspecifiedPayer) {
      initialValues.insurance[coverage].payerName = null;
    }
  });
};

const setCareGiverIfOkToSpeakToInitialValues = (initialValues) => {
  if ([YES, okToSpeakTo, contactInsteadOfPatient].includes(initialValues.patient.hasCaregiver)) {
    initialValues.patient.hasCaregiver = YES;
  } else {
    initialValues.patient.careGiver = {
      firstName: null,
      lastName: null,
      phoneType: mobile,
      phone: null
    };
  }
};

const setPhysicianInitialValues = (initialValues) => {
  if (typeof initialValues.physician?.name === "object") {
    const physician = initialValues.physician?.name;
    initialValues.physician.name = physician?.name;
    initialValues.physician.npi = physician?.npi;
    initialValues.physician.stateLicense = physician?.stateLisence;
    initialValues.physician.taxId = physician?.taxId;
    initialValues.physician.dea = physician?.dea;
    initialValues.physician.treatmentSiteNPI = physician?.treatmentSiteNPI;
    initialValues.physician.treatmentSiteTaxId = physician?.treatmentSiteTaxId;
  }
};
